import { createAction, props } from '@ngrx/store';

import { ErrorMessage } from '@priva/appshell';

import { SiteAsset } from '.';

export const getSites = createAction('[Site] Get all sites');
export const getSitesSuccess = createAction(
    '[Site] Get all sites (success)',
    props<{ sites: SiteAsset[] }>(),
);
export const getSitesError = createAction('[Site] Get all sites (error)', props<{ error: ErrorMessage }>());
